import { Injectable } from '@angular/core'
import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent, HttpHeaders } from '@angular/common/http'
import { Observable } from 'rxjs/Observable'

import { environment } from '../environments/environment'

@Injectable()
export class BaseUrlInterceptor implements HttpInterceptor {
  private baseUrl: string = environment.BASE_URL

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
      'X-Requested-With': 'XMLHttpRequest',
    })

    const isFullUrl = /^https?:\/\//i.test(req.url)

    const apiReq = isFullUrl ? req.clone({ headers }) : req.clone({ url: `${this.baseUrl}${req.url}` })

    return next.handle(apiReq)
  }
}



// WEBPACK FOOTER //
// /srv/staging/FitRadioAdmin2/src/app/base-url.interceptor.ts